import React from 'react'

//
import { ButtonNew, IntegrationSection } from '../../../storybook'
import { getUrl } from '../../../utils/urls'
import { LocationContext, SiteDataContext } from '../../page-wrapper'
import { BUTTON_VARIANT } from '@/src/storybook/ButtonNew/ButtonNew'
import { useNavigationData } from '@/src/context/NavigationContext'

const Block2ColumnsIntegrationList = ({
  data: { title, description, action, column1Integrations }
}) => {
  const { navigationItems } = useNavigationData()
  const { market, lang } = React.useContext(SiteDataContext)
  const location = React.useContext(LocationContext)
  const { slugPrefix } = location

  const getIntegrationsList = (integrations) => {
    if (integrations?.length > 0) {
      return integrations.map(({ id, title, categories = [], logo, logoLight, slug, markets }) => {
        const isAvailableInMarket = markets.find(
          (m) => m.countryIsoCode?.toLowerCase() === market.isoCode?.toLowerCase()
        )
        const isEnglishGlobal = market.isoCode.toLowerCase() === 'xx' && lang === 'en'
        return {
          id,
          title,
          type: categories.map((cat) => cat.title)[0],
          url: isAvailableInMarket
            ? `${slugPrefix}/integrations/${slug}`.replace('//', '/')
            : isEnglishGlobal
            ? `/en/integrations/${slug}`
            : '',
          logo: logoLight?.url || logo?.url || '',
          markets
        }
      })
    }
    return []
  }

  const actionButton = (
    <ButtonNew
      url={getUrl({
        navItem: action,
        slugPrefix: slugPrefix,
        navigationItems: navigationItems
      })}
      classes={'c-integration-section__action-button'}
      variant={BUTTON_VARIANT.GREEN}
    >
      {action?.title || ''}
    </ButtonNew>
  )

  return (
    <IntegrationSection
      title={title || ''}
      description={description || ''}
      posIntegrations={getIntegrationsList(column1Integrations)}
      action={actionButton}
    ></IntegrationSection>
  )
}

export default Block2ColumnsIntegrationList
